export default "__VITE_ASSET__Cnnf0Qjt__"